module.exports = __webpack_public_path__ + "img/outlook.427a02a3.png";